// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline-chart-container {
  /* width: 100%; */
  /* max-height: 30vh; */
  height: 30vh;
  margin: 3px 10px;
  padding: 5px;
  background-color: rgba(51, 51, 51, 0.4);
  color: white;
}

.chart {
  width: 100% !important;
  height: 100% !important;
}



.vertical-line {

  position: absolute;
  left: -1;

  width: 5px;
  pointer-events: none;
  background: linear-gradient(0deg, rgb(226, 226, 231), rgb(215, 243, 129));
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.5); /* Subtle shadow */
}



.vertical-line::before,
.vertical-line::after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  top: -6px; /* Adjust this value to position properly */
  left: 50%;
  transform: translateX(-50%);
  border-width: 0 3px 6px 3px; /* Adjusted to match the line width */
  border-color: transparent transparent rgb(226, 226, 231) transparent;
}

.vertical-line::after {
  top: auto;
  bottom: -6px; /* Adjust this value to position properly */
  border-width: 6px 3px 0 3px;
  border-color: rgb(215, 243, 129) transparent transparent transparent; /* Match gradient color for the other end */
}

.vertical-line-low {
  position: absolute;
  left: -1;
  pointer-events: none;
  width: 4px;
  background: linear-gradient(0deg, rgb(226, 226, 231, 0.2), rgb(215, 243, 129,0.3));
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.3); /* Subtle shadow */

}


#chart-resizer {
  position: absolute;
  width: 100px;
  height: 8px;
  border-radius: 5px;
  background: gray;
  right: calc(50% - 50px);
  top: -1px;
  cursor: ns-resize;
}

/* Anchor for controls that float over the chart. Zero height, so it costs no
   layout space at all — the timeline bar is the tightest row on a phone and
   nothing new may compete for it.

   It exists because \`.timeline-chart-container\` must NOT become
   \`position: relative\`: the time stick and #chart-resizer are positioned
   against the current containing block, and giving them a new one makes them
   jump. A positioned wrapper of its own keeps that blast radius at zero. The
   z-index puts it over the canvas, which is unpositioned. */
.chart-overlay {
  position: relative;
  height: 0;
  z-index: 2;
}

.chart-overlay button {
  position: absolute;
  top: 4px;
  right: 6px;
  width: 26px;
  height: 26px;
  padding: 4px;
  line-height: 0;
  border: none;
  border-radius: 4px;
  background: rgba(51, 51, 51, 0.55);
  cursor: pointer;
}

.chart-overlay button:hover {
  background: rgba(119, 119, 119, 0.9);
}

.chart-overlay img {
  display: block;
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/burnair/modules/timeChart/timeChart.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;;;AAIA;;EAEE,kBAAkB;EAClB,QAAQ;;EAER,UAAU;EACV,oBAAoB;EACpB,yEAAyE;EACzE,6CAA6C,EAAE,kBAAkB;AACnE;;;;AAIA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,SAAS,EAAE,2CAA2C;EACtD,SAAS;EACT,2BAA2B;EAC3B,2BAA2B,EAAE,qCAAqC;EAClE,oEAAoE;AACtE;;AAEA;EACE,SAAS;EACT,YAAY,EAAE,2CAA2C;EACzD,2BAA2B;EAC3B,oEAAoE,EAAE,2CAA2C;AACnH;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV,kFAAkF;EAClF,6CAA6C,EAAE,kBAAkB;;AAEnE;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;;;;;4DAQ4D;AAC5D;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd","sourcesContent":[".timeline-chart-container {\n  /* width: 100%; */\n  /* max-height: 30vh; */\n  height: 30vh;\n  margin: 3px 10px;\n  padding: 5px;\n  background-color: rgba(51, 51, 51, 0.4);\n  color: white;\n}\n\n.chart {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n\n\n.vertical-line {\n\n  position: absolute;\n  left: -1;\n\n  width: 5px;\n  pointer-events: none;\n  background: linear-gradient(0deg, rgb(226, 226, 231), rgb(215, 243, 129));\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.5); /* Subtle shadow */\n}\n\n\n\n.vertical-line::before,\n.vertical-line::after {\n  content: '';\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  top: -6px; /* Adjust this value to position properly */\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 0 3px 6px 3px; /* Adjusted to match the line width */\n  border-color: transparent transparent rgb(226, 226, 231) transparent;\n}\n\n.vertical-line::after {\n  top: auto;\n  bottom: -6px; /* Adjust this value to position properly */\n  border-width: 6px 3px 0 3px;\n  border-color: rgb(215, 243, 129) transparent transparent transparent; /* Match gradient color for the other end */\n}\n\n.vertical-line-low {\n  position: absolute;\n  left: -1;\n  pointer-events: none;\n  width: 4px;\n  background: linear-gradient(0deg, rgb(226, 226, 231, 0.2), rgb(215, 243, 129,0.3));\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.3); /* Subtle shadow */\n\n}\n\n\n#chart-resizer {\n  position: absolute;\n  width: 100px;\n  height: 8px;\n  border-radius: 5px;\n  background: gray;\n  right: calc(50% - 50px);\n  top: -1px;\n  cursor: ns-resize;\n}\n\n/* Anchor for controls that float over the chart. Zero height, so it costs no\n   layout space at all — the timeline bar is the tightest row on a phone and\n   nothing new may compete for it.\n\n   It exists because `.timeline-chart-container` must NOT become\n   `position: relative`: the time stick and #chart-resizer are positioned\n   against the current containing block, and giving them a new one makes them\n   jump. A positioned wrapper of its own keeps that blast radius at zero. The\n   z-index puts it over the canvas, which is unpositioned. */\n.chart-overlay {\n  position: relative;\n  height: 0;\n  z-index: 2;\n}\n\n.chart-overlay button {\n  position: absolute;\n  top: 4px;\n  right: 6px;\n  width: 26px;\n  height: 26px;\n  padding: 4px;\n  line-height: 0;\n  border: none;\n  border-radius: 4px;\n  background: rgba(51, 51, 51, 0.55);\n  cursor: pointer;\n}\n\n.chart-overlay button:hover {\n  background: rgba(119, 119, 119, 0.9);\n}\n\n.chart-overlay img {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
